import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const UserRegister = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      navigate('/user-dashboard');
    } else {
      // Redirect to login page (Google OAuth only)
      navigate('/login');
    }
  }, [user, navigate]);

  return null; // This page just redirects
};

export default UserRegister;